<template>
  <SearchedUserSecondary
    :tenantUser="expert"
    :tenantUserSkills="expert.tenantUserSkills"
  />
</template>

<script>
  import SearchedUserSecondary from '@modules/search/searched-user-secondary'
  import { Layout } from '@js/styles'

  export default {
    name: 'SearchedUserVertical',
    components: {
      SearchedUserSecondary,
    },
    props: {
      expert: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        containerStyle: {
          display: 'flex',
          height: Layout.space.md,
          margin: `0 0 0 ${Layout.space.xs}`,
          width: '100%',
        },
      };
    },
  };
</script>
